/**
 * Cmarkdownxychart — shared types
 */

export const XYCHART_AXIS_TYPE = {
  Categorical: 'categorical',
  Numeric: 'numeric',
} as const;

export type XYChartAxisType = (typeof XYCHART_AXIS_TYPE)[keyof typeof XYCHART_AXIS_TYPE];

export const XYCHART_SERIES_TYPE = {
  Bar: 'bar',
  Line: 'line',
} as const;

export type XYChartSeriesType = (typeof XYCHART_SERIES_TYPE)[keyof typeof XYCHART_SERIES_TYPE];

export interface XYChartXAxis {
  title: string | null;
  type: XYChartAxisType;
  categories: string[];
  min: number | null;
  max: number | null;
}

export interface XYChartYAxis {
  title: string | null;
  min: number | null;
  max: number | null;
}

export interface XYChartDataSeries {
  type: XYChartSeriesType;
  data: number[];
  colorIndex: number;
  label: string;
}

export interface XYChartParsed {
  title: string | null;
  horizontal: boolean;
  xAxis: XYChartXAxis;
  yAxis: XYChartYAxis;
  series: XYChartDataSeries[];
}

export interface XYChartPoint {
  x: number;
  y: number;
}

export interface XYChartMargins {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export interface XYChartTickLayout {
  value: number;
  position: number;
  label: string;
}

export interface XYChartBarDatum {
  categoryIndex: number;
  value: number;
  path: string;
  centerX: number;
  centerY: number;
  zeroX: number;
  zeroY: number;
}

export interface XYChartLinePoint {
  categoryIndex: number;
  value: number;
  x: number;
  y: number;
}

export interface XYChartSeriesLayout {
  seriesIndex: number;
  type: XYChartSeriesType;
  color: string;
  label: string;
  bars: XYChartBarDatum[];
  linePoints: XYChartLinePoint[];
  linePath: string;
  areaPath: string;
}

export interface XYChartCategoryLabel {
  text: string;
  fullText: string;
  position: number;
}

export interface XYChartLayout {
  width: number;
  height: number;
  margins: XYChartMargins;
  plotWidth: number;
  plotHeight: number;
  horizontal: boolean;
  categories: XYChartCategoryLabel[];
  rotateCategoryLabels: boolean;
  ticks: XYChartTickLayout[];
  valueDomain: [number, number];
  zeroPosition: number;
  series: XYChartSeriesLayout[];
  xAxisTitle: string | null;
  yAxisTitle: string | null;
  /** Pixel position (along the category axis) of each category center. */
  categoryCenters: number[];
}
